import { useQueryClient } from '@tanstack/react-query';

import {
	ASSET_CART_REQUEST,
	ASSET_CART_REQUEST_AVAILABLE,
	ASSET_CART_REQUEST_COUNT,
	ASSET_CART_REQUEST_DROPDOWN,
	ASSET_CART_REQUEST_UNAVAILABLE,
} from '@constants/queryKeys';

export const useInvalidateAcquiredAssets = () => {
	const queryClient = useQueryClient();

	const invalidateAcquiredAssets = () => {
		return [
			queryClient.invalidateQueries([ASSET_CART_REQUEST]),
			queryClient.invalidateQueries([ASSET_CART_REQUEST_COUNT]),
			queryClient.invalidateQueries([ASSET_CART_REQUEST_DROPDOWN]),
			queryClient.invalidateQueries([ASSET_CART_REQUEST_AVAILABLE]),
			queryClient.invalidateQueries([ASSET_CART_REQUEST_UNAVAILABLE]),
		];
	};

	return {
		invalidateAcquiredAssets,
	};
};
